var _clipPath, _clipPath2, _linearGradient, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGermany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 284.747,
    height: 351.188,
    viewBox: "0 0 44.875 55.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504 31h49v60h-49z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M533.88 34.855h-3.875l3.133 2.383-1.196 3.855 3.137-2.383 3.133 2.383-1.195-3.855 3.132-2.383h-3.875l-1.195-3.848zm-12.738 0h-3.875l3.133 2.383-1.195 3.855 3.132-2.383 3.137 2.383-1.2-3.855 3.134-2.383h-3.875l-1.196-3.848zm25.48 4.887h-3.875l3.133 2.382-1.195 3.852 3.132-2.379 3.137 2.38-1.195-3.853 3.133-2.382h-3.875l-1.2-3.852zm-38.223 0h-3.875l3.133 2.382-1.195 3.852 3.132-2.379 3.137 2.38-1.195-3.853 3.133-2.382h-3.875l-1.2-3.852zm-2.723 28.113c0 5.386 1.848 10.34 4.946 14.262l1.683-1.325a20.787 20.787 0 0 1-4.488-12.938c0-11.535 9.352-20.887 20.891-20.887 11.535 0 20.891 9.352 20.891 20.887 0 4.88-1.676 9.372-4.48 12.926l1.683 1.329a22.954 22.954 0 0 0 4.938-14.254c0-12.72-10.312-23.031-23.031-23.031s-23.031 10.312-23.031 23.03m4.304 0c0 10.329 8.403 18.728 18.727 18.728s18.723-8.399 18.723-18.727c0-10.324-8.398-18.723-18.723-18.723s-18.727 8.398-18.727 18.723m.864 0c0-9.848 8.015-17.863 17.863-17.863 9.847 0 17.863 8.015 17.863 17.863 0 9.851-8.016 17.863-17.863 17.863-9.852 0-17.863-8.012-17.863-17.863m17.684-16.82c-.543.011-.91.355-.903.816.008.504.336.71.758.875.316.113.441.219.445.418.004.164-.125.277-.382.281-.305.008-.477-.203-.563-.328l-.363.406c.152.215.437.47.945.461.637-.011 1-.398.992-.875-.008-.484-.258-.668-.715-.855-.367-.149-.503-.219-.503-.422 0-.156.12-.25.32-.254a.593.593 0 0 1 .5.266l.36-.38c-.16-.21-.41-.41-.864-.41h-.027m-4.157.59.102.524.781-.156.442 2.23.593-.117-.441-2.227.789-.156-.106-.523zm5.946.899c-.164.883.293 1.55 1.144 1.707.543.101.902-.055 1.176-.32l-.336-.426c-.168.168-.379.27-.73.207-.48-.09-.747-.516-.645-1.063.102-.535.496-.828.984-.738.278.05.465.2.563.441l.496-.285c-.168-.347-.457-.597-.961-.687a1.688 1.688 0 0 0-.309-.031c-.691 0-1.242.457-1.382 1.195m-7.66-.313.648 1.516c.172.398.074.7-.258.84-.336.144-.621.008-.793-.395l-.644-1.511-.559.238.644 1.508c.313.734.868.96 1.555.668.695-.297.91-.86.602-1.586l-.645-1.512zm10.522 2.371.555.239.453-1.047.996.43-.453 1.046.555.243 1.11-2.579-.555-.238-.446 1.031-.992-.43.442-1.03-.555-.239zm-14.793.04 1.61 2.296 1.504-1.058-.309-.438-1.008.711-.363-.515.852-.602-.29-.41-.851.598-.348-.5.977-.688-.3-.426zm17.7 1.359 1.503 1.062.309-.437-1.008-.715.363-.512.848.602.293-.414-.848-.602.352-.496.973.692.304-.43-1.469-1.04zm-20.302 11.875c0 7.137 5.786 12.922 12.922 12.922s12.922-5.785 12.922-12.922c0-7.133-5.785-12.918-12.922-12.918s-12.922 5.785-12.922 12.918m.743 0c0-6.723 5.453-12.176 12.18-12.176 6.722 0 12.176 5.453 12.176 12.176 0 6.726-5.453 12.18-12.176 12.18-6.727 0-12.18-5.453-12.18-12.18m21.664-10.281.418.441.687-.652.14.152-.253 1.106.504.535.25-1.242c.36.176.718.133 1.015-.149.438-.414.387-.941-.117-1.476l-.605-.64zm1.648-.328-.2-.207.622-.586.2.207c.233.254.253.496.062.672a.407.407 0 0 1-.286.129c-.128 0-.265-.07-.398-.215m-23.547-.656-.613.66 2.05 1.91.618-.656c.656-.707.652-1.477-.008-2.09-.29-.266-.602-.403-.918-.403-.38 0-.77.196-1.13.579m.188.582.227-.243c.383-.41.824-.425 1.215-.062.406.379.433.828.047 1.238l-.223.242zm11.98.894c-.414.028-.832.332-1.941.332-1.106 0-.914 1.418-.914 1.418s.516-.152.906-.14c.387.007 1.39-.012 1.09.605 0 0-.805-.285-1.184-.285-.379 0-1.285-.012-1.511-.34-.227-.332-.313-.434-.313-.434s-.258 1.04.332 1.141c.586.106 1.192 0 1.473-.02.285-.019.844-.019.992 0 .152.02-.008.18-.3.2-.294.02-.966-.028-.786.273.18.305.492.473.68.512.191.039.71-.047.484.512l-.129.37c-.144.427-.601 1.427-1.633 1.247-1.035-.18-1.187-.254-.789-.785 1.27-1.68 1.102-2.121-.687-2.106-1.848.024-2.078.008-2.078.008s-.703-.055-.973.84c-.32 1.043-2.785 7.66-2.785 7.66s-.11.64.43.816c.703.235.933-.449.933-.449l1.79-4.734c.132.082.26.164.394.242l-2.23 6.187s-.231.684.488.938c.648.223.937-.582.937-.582l2.148-5.856c.114.047.227.098.34.145l-2.265 6.469s-.207.691.46.918.942-.567.942-.567l2.246-6.36c.133.036.266.071.395.103v.011l-1.145 3.817s-.187.652.453.906c.645.25.997-.606.997-.606l1.046-3.367s.43 1.754-.328 2.977c-.754 1.223-1.496 2.039-2.468 2.492 0 0 .027.14.378.164.356.027.38.117.43.176l-.504.77s-.074.28-.418.128c-.34-.152-.765-.379-.765-.379s-.442-.113-.543.102l-.102.215s-.504.05-.566.34c-.067.289.023.328.023.328s.23-.16.328-.102c.133.082.024.324.184.383.281.102.488-.055.637-.191.097-.094.34.011.351.086.016.078-.101.277-.39.316-.29.039-.918.148-.883.48.03.274.035.301.039.301-.004.004-.239.504.238.692 0 0 .078-.301.176-.301.101 0 .191.176.367.176s.34-.153.441-.454c.102-.304.278-.707.278-.707s.125-.148.203-.125c.074.024.113.165.086.25-.024.09-.074.293-.086.344-.016.047-.442.578-.102.832.34.25.305.352.39.414.087.067.442.192.567.114 0 0-.148-.278-.187-.329-.04-.046-.027-.148.21-.148.243 0 .243-.305.09-.531-.148-.227-.203-.446-.253-.594-.098-.297.172-.402.293-.102.117.297.07.579.328.54.191-.032.238-.16.328-.149.086.016.336.188.203.512 0 0 .59-.094.39-.637-.132-.355-.296-.176-.19-.527.081-.278-.165-.48-.454-.469-.273.012-.625-.063-.453-.39.18-.348.426-.77.426-.77l.418.48s.39-.984.746-1.426c.351-.44.781-.984.98-.867.203.11.266 1.535.102 2.254s-.758 2.297-.895 2.512c-.14.21.782-.14.895-.18.113-.035.34-.312.39.117.051.426.22 1.243.61 1.66l.008-.011c.39-.414.582-1.258.633-1.688.047-.43.273-.152.39-.113.114.035 1.036.39.89.176-.136-.215-.726-1.793-.89-2.508-.164-.719-.101-2.144.102-2.258.2-.113.629.43.98.867.352.442.746 1.426.746 1.426l.415-.476s.25.418.43.77c.171.327-.18.398-.454.386-.293-.008-.539.195-.453.469.105.351-.059.172-.191.531-.2.539.386.637.386.637-.133-.328.117-.5.207-.512.09-.012.133.113.328.144.258.04.211-.242.329-.535.12-.304.386-.199.289.102-.051.148-.102.363-.25.59-.153.226-.153.531.085.531.239 0 .254.102.215.152-.039.051-.191.328-.191.328.129.075.48-.05.57-.117.086-.062.051-.16.39-.414.34-.254-.089-.781-.1-.832a6.706 6.706 0 0 0-.09-.34c-.024-.09.011-.226.09-.254.074-.023.202.125.202.125s.176.407.274.707c.101.305.27.457.441.457.18 0 .266-.18.367-.18s.18.305.18.305c.473-.19.242-.687.238-.695l.04-.3c.035-.329-.594-.442-.887-.481-.29-.04-.403-.238-.39-.313.01-.078.253-.18.355-.09.148.137.351.294.636.192.157-.055.047-.3.184-.383.098-.058.328.102.328.102s.086-.04.023-.328-.566-.34-.566-.34l-.101-.215c-.102-.211-.543-.102-.543-.102s-.43.23-.77.38c-.34.152-.414-.126-.414-.126l-.402-.87c.047-.063.074-.15.425-.177.352-.027.38-.164.38-.164-.97-.453-1.462-1.12-2.22-2.343-.757-1.223-.328-2.977-.328-2.977l1.047 3.367s.352.86.996.606c.641-.254.454-.91.454-.91l-1.168-3.907v-.011c.128-.032.257-.07.39-.11l1.926 6.414s.27.793.937.567.461-.922.461-.922l-1.957-6.563c.11-.047.223-.097.336-.152v.008l1.848 5.949s.29.805.934.582c.718-.254.492-.934.492-.934l-1.95-6.328v-.004c.126-.078.25-.156.376-.242.039.04.046.082.046.082l1.481 4.797s.227.68.934.445c.539-.175.43-.816.43-.816s-1.97-6.516-2.286-7.559c-.273-.894-.973-.836-.973-.836s-.23.008-2.082-.011c-1.785-.02-1.957.426-.687 2.101.402.536.246.61-.785.79-1.035.18-1.528-.829-1.586-1.274-.063-.445-.29-2.023-.317-2.102-.066-.187.418-.328.653-.175.433.273.37.363.37-.457s-1.085-.754-1.085-.754c-.05-.614-.71-.719-1.238-.719-.223 0-.422.02-.543.027m-.047 1.145c-.18-.008-.344-.188-.344-.188s.098-.18.332-.172c.238.008.344.172.344.172s-.145.188-.32.188h-.012m9.68 9.87-1.497-4.882c.122-.09.243-.183.368-.277v.004c.043.117 1.53 5.043 1.53 5.043s.141.332-.089.418a.177.177 0 0 1-.062.011c-.176 0-.25-.316-.25-.316m-19.11.344c-.222-.11-.058-.422-.058-.422s1.703-4.383 1.875-4.809c.121.09.242.176.363.258l-1.844 4.691s-.09.297-.261.297a.18.18 0 0 1-.075-.015m17.785 1.8-1.851-5.976c.133-.067.258-.137.39-.211.13.402 1.864 6.074 1.864 6.074s.14.328-.086.418a.217.217 0 0 1-.066.012c-.18 0-.25-.317-.25-.317m-16.418.278c-.22-.098-.067-.418-.067-.418s1.832-5.067 2.125-5.871l.39.195-2.116 5.809s-.086.304-.258.304a.19.19 0 0 1-.074-.02m14.793.86-1.965-6.355c.133-.047.27-.098.406-.149.215.68 1.96 6.39 1.96 6.39s.142.325-.089.415a.134.134 0 0 1-.062.015c-.18 0-.25-.316-.25-.316m-13.172.32c-.223-.093-.07-.418-.07-.418l2.198-6.304c.141.05.278.097.415.14l-2.22 6.293s-.081.305-.253.305a.153.153 0 0 1-.07-.016m10.586-2.363-1.168-3.73s-.028-.051.015-.121c.121-.024.25-.047.379-.075.074.227 1.176 3.813 1.176 3.813s.14.328-.086.414a.138.138 0 0 1-.066.015c-.18 0-.25-.316-.25-.316m-7.676.293c-.227-.09-.09-.414-.09-.414s.887-2.977 1.125-3.75c.148.027.293.05.43.07l-1.153 3.79s-.066.316-.25.316a.194.194 0 0 1-.062-.012m16.488 3.191-.371.817 2.547 1.148.367-.82c.394-.875.144-1.598-.668-1.965a1.55 1.55 0 0 0-.629-.148c-.52 0-.961.336-1.246.968m.363.485.133-.3c.23-.509.64-.665 1.125-.446.504.23.672.64.441 1.152l-.132.3zm-28.664-.293.246.55.903-.402.418.93.468-.207-.418-.934.696-.308.46 1.031.481-.219-.707-1.578zm2.277 2.043c-.64.465-.742 1.055-.308 1.652.441.613 1.035.703 1.676.242l1.324-.957-.348-.48-1.328.957c-.351.25-.668.226-.879-.067-.207-.292-.137-.605.215-.855l1.328-.957-.351-.488zm24.801-.117 1.356 1.039-.004.004-2.074-.102-.442.57.344.02 1.988 1.527.364-.472-1.348-1.036.004-.003 2.059.109.328-.43-2.211-1.699zm-22.035 2.195c-.34.367-.242.742-.046 1.152.148.297.168.461.035.61-.114.12-.282.113-.469-.059-.227-.203-.207-.473-.188-.625l-.535.047c-.035.262-.004.64.371.98.47.43.989.399 1.313.047.324-.355.27-.66.066-1.11-.164-.358-.218-.503-.078-.651.106-.114.258-.098.406.039a.59.59 0 0 1 .18.53l.516-.03c.031-.266-.02-.586-.363-.903-.204-.187-.434-.281-.649-.281a.747.747 0 0 0-.559.254m19.88.21 1.035 1.27c.277.336.265.653-.012.88-.277.226-.594.175-.867-.16l-1.035-1.27-.47.382 1.036 1.266c.504.613 1.098.676 1.668.207.586-.476.637-1.074.14-1.684l-1.035-1.265zm-17.907 1.497c-.265.422-.105.773.157 1.144.203.266.25.426.144.594-.09.137-.258.16-.472.024-.258-.16-.29-.43-.293-.582l-.52.14c.008.266.11.63.535.903.54.34 1.047.214 1.301-.188.258-.406.148-.695-.129-1.101-.226-.325-.3-.461-.191-.63.082-.132.238-.14.406-.035.227.141.262.356.273.493l.5-.121c-.02-.266-.12-.579-.515-.825a1.018 1.018 0 0 0-.547-.172c-.266 0-.5.125-.649.356m14.97.496-.81.414 1.266 2.488.864-.441c.601-.309.77-.734.558-1.148-.164-.329-.496-.415-.777-.329l-.004-.007c.191-.184.27-.457.11-.778a.638.638 0 0 0-.598-.37c-.176 0-.38.054-.61.171m-.043.59.258-.133c.246-.125.418-.094.512.094.094.183.02.363-.219.484l-.258.133zm.504.988.29-.148c.273-.137.464-.106.562.086.098.191.015.367-.254.507l-.297.149zm-13.836 1.223.903.36c.629.245 1.058.09 1.23-.34a.637.637 0 0 0-.27-.801l.005-.012c.265.023.52-.098.652-.43.164-.414-.035-.793-.645-1.035l-.843-.336zm1.434-1.192-.27-.109.239-.601.27.105c.257.105.347.25.269.45-.055.128-.153.198-.293.198a.582.582 0 0 1-.215-.043m-.379 1.063-.309-.121.25-.621.301.12c.285.11.387.278.309.477-.055.133-.153.204-.293.204a.709.709 0 0 1-.258-.059m3.2-1.172-1.45 2.332.621.11.293-.504.973.168.105.574.645.113-.621-2.941-.63-.114zm-.278 1.492.453-.781h.008l.16.89zm4.875-1.57.496 2.746 1.598-.289-.098-.535-1.004.183-.398-2.214zm-2.293.11.043 2.792 1.62-.027-.007-.543-1.02.016-.03-2.246zm7.71 5.605.739 2.012a23.059 23.059 0 0 0 8.938-5.985l-1.57-1.457a20.924 20.924 0 0 1-8.106 5.43m-24.152-3.965a23.052 23.052 0 0 0 8.941 5.98l.742-2.011a20.892 20.892 0 0 1-8.113-5.422zm21.027-.914.144.457 1.004-.316-.144-.457zm-4.117 6.168c-1.965 0-3.864-.27-5.665-.777l-.582 2.062c1.985.559 4.082.86 6.246.86 2.172 0 4.27-.301 6.262-.864l-.582-2.062c-1.805.508-3.71.781-5.68.781"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -0.168,
    x2: 1.113,
    gradientTransform: "scale(60.1) rotate(-51 5.656 -8.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#887b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#887b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#897b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#8a7c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#8a7d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#8b7e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#8c7e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#8c7f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#8d8030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#8e8131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#8f8232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#8f8233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#908334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#918334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#918435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#928436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#928537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#938637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#948738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#948839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#95883a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#95893a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#96893b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#978a3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#988b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#998c3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#998c3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9a8d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#9a8d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#9b8e41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#9b8e41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#9c8f42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#9d9043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#9e9144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#9e9145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#9f9246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#9f9347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#a09348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#a19448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#a19549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#a2964a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#a3974b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#a3974c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#a4984d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#a5984e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#a69a4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#a69b50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#a79b51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#a79c52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#a89c53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#a89d54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#a99e55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#aa9e56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#ab9f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#aca057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#aca159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#ada15a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#ada25b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#aea35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#aea35d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#afa35e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363,
    stopColor: "#b0a55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#b1a661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#b1a762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#b2a863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#b3a864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#b3a865"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#b4aa66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#b5ab67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#b6ab68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#b6ac69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#b7ad6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#b7ad6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#b8ae6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    stopColor: "#b9af6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.418,
    stopColor: "#bab06e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#bbb16f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#bcb171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#bdb272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434,
    stopColor: "#bdb373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#beb374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#beb475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#bfb476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    stopColor: "#c0b577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#c1b678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#c2b779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#c2b77a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#c3b87b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#c3b97c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#c4ba7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#c5bb7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c6bb80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#c6bc82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#c6bd83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#c7be84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    stopColor: "#c8bf85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c9bf86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#cac188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#cbc28a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#ccc38b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#cdc48c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#cdc48d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#cdc58d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#cdc48c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#ccc38b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#cbc28a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#cac188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#c9bf86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#c8be85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#c7be84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#c6bd83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#c6bc82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#c6bc80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#c5bb7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#c4b97e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#c3b97c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#c3b87b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#c2b77a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586,
    stopColor: "#c2b779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#c1b678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#c0b577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#bfb476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#beb475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#beb374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#bdb372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#bdb272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617,
    stopColor: "#bcb171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#bbb06f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#baaf6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#b9af6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#b8ae6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#b7ad6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#b7ad6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#b6ac69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#b6ab68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#b5aa67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#b4a966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#b3a965"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#b3a864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#b2a863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#b1a762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#b1a660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#b0a55f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#afa45e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#aea35d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#aea35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#ada25b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#ada25a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#aca159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707,
    stopColor: "#aca058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#ab9f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#aa9e56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#a99d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723,
    stopColor: "#a89d54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#a89c53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#a79c52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#a79b51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    stopColor: "#a69a50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#a5994f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#a5994e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#a4984d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#a3974c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#a3974c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#a2964a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#a29549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#a19449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#a09348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#9f9347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#9f9246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#9e9145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#9d9145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793,
    stopColor: "#9d9043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#9c8f42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#9b8e42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#9a8d41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#9a8d40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#9a8d3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#998c3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#988c3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#988b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#978a3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#96893b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#95893a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#95883a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#948739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#938738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#938637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#928536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#928436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#918435"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#918335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#908334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#8f8233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#8e8132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#8e8131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.887,
    stopColor: "#8d8031"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891,
    stopColor: "#8c7f30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#8c7e2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#8b7e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#8a7d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#8a7d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#897c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#897c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#897c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#897c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#897c2c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(-513.82 -43.229)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    x: 59.342,
    y: 797.822
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    x: 40.788,
    y: 812.822
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    x: 559.297,
    y: 630.353
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    x: 565.995,
    y: 630.353
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    x: 572.693,
    y: 684.073
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    x: 572.693,
    y: 695.573
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    x: 572.693,
    y: 707.073
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: 572.897,
    y: 321.05
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: 572.887,
    y: 321.05
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: 572.887,
    y: 343.05
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    x: 572.887,
    y: 343.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.092,
    clipPath: "url(#e)",
    transform: "translate(-451.59 -27.087) scale(.89679)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m475.24 67.172 58.5 47.371 48.441-59.82-58.496-47.371z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.a43bb166a3704e299c354ce34648fe1e.svg";
export { ForwardRef as ReactComponent };